import React, { useState } from 'react';
import './modalsenha.css'; // estilos opcionais
import  { cryptRC4, fromHexDump }  from '../../services/funcoes';
import { dataHoraAtualBrasileira, formatarData2, estaDentroDoIntervalo } from '../../services/datautils';


export default function ModalAutorizacao({identificador, onConfirmar, onCancelar }) {
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');

  const validarSenha = async () => {
    try {
      if (senha.length !== 16) {
        setErro('Senha inválida');
        return;
      }

      const dataAtual = dataHoraAtualBrasileira() + ':00';
      const dataFormatada = formatarData2(dataAtual, 'aaaammdd');
      const lsPalavra = identificador + dataFormatada //'JG-0000720251027'; JG-0000720251027
      const lsSenha = cryptRC4(fromHexDump(senha), lsPalavra);
      const lsData = formatarData2(dataAtual, 'dd/mm/aaaa') + ' ' + lsSenha.substring(0,2) + ':' + lsSenha.substring(2,4) + ":00";
      const lsIntervalo = lsSenha.substring(4,5);
      const lsQtd = lsSenha.substring(5);

      if (estaDentroDoIntervalo(lsData, lsQtd, lsIntervalo)) {
          onConfirmar(); // libera edição

        } else {
          setErro('Senha inválida ou sem permissão');
        }
    } catch (err) {
      console.log('Err: ', err)/
      setErro('Erro ao validar senha');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-conteudo">
        <h2>Autorização necessária</h2>
        <p>Digite a senha fornecida:</p>
        <input
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          placeholder="Senha de autorização"
        />
        {erro && <p className="erro">{erro}</p>}
        <div className="flex gap-4 pt-6 mt-6 mb-6 border-t border-secondary justify-center">
          <button  
            className='border border-secondary text-secondary hover:bg-secondary hover:text-white px-10 py-2 rounded-md'
            onClick={validarSenha}>Confirmar</button>
          <button           
            className='border border-red-500 text-red-500 hover:bg-red-500 hover:text-white px-10 py-2 rounded-md' 
            onClick={onCancelar}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}